// extracted by mini-css-extract-plugin
module.exports = {"dateOverview":"styles_dateOverview__1o-_i"};